import React, { useState, useEffect } from 'react'
import { createPortal } from 'react-dom';
import { Button, Radio, Typography, DatePicker, Tree, Select, Empty, Spin, Row, Col } from 'antd';
import moment from 'moment';
import axios from 'axios';
import { ArrowLeftOutlined, CalendarOutlined, FieldTimeOutlined, SaveOutlined, SettingOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import { Levels } from '../../constants'
import './AssessmentAssignPanel.css';

const { Text } = Typography;
const { RangePicker } = DatePicker;
const { Option } = Select

export default function MasteryAssignTool(props) {
   // const assOptionState = useSelector(state => state.assOptionState)
   // const dispatch = useDispatch();   
   const [expandedKeys, setExpandedKeys] = useState([]);
   const [checkedKeys, setCheckedKeys] = useState([]);
   const [selectedKeys, setSelectedKeys] = useState([]);
   // const [autoExpandParent, setAutoExpandParent] = useState(true);
   const [treeData, setTreeData] = useState([]);

   const [sectionLoading, setSectionLoading] = useState(false);
   const [studentListLoading, setStudentListLoading] = useState(false);
   const [sectionList, setSectionList] = useState([]);
   const [manualSaveSlotReady, setManualSaveSlotReady] = useState(false);

   useEffect(() => {
      if (props.manualSaveSlotId) {
         setManualSaveSlotReady(true);
      }
   }, [props.manualSaveSlotId]);

   const dateFormat = 'MMM D, YYYY h:mm a';
   const customFormat = value => `${value.format(dateFormat)}`;

   var ass_options = props.options;

   useEffect(() => {
      // Utils.verifyJwt();

      if (props.options.level !== undefined && props.options.level !== null && props.options.level !== 0 &&
         props.options.section !== undefined && props.options.section !== null && props.options.section !== 0) {

         ass_options.level = props.options.level;
         ass_options.section = props.options.section;
         setExpandedKeys([]);
         setSectionLoading(true);
         setStudentListLoading(true);

         axios.get(`${process.env.REACT_APP_API_LOOKUP}/sectionlistbylevel?level=${ass_options.level}`).then((response) => {
            if (response.data) {
               const data = response.data;

               setSectionList(data);
               setSectionLoading(false);

               axios.get(`${process.env.REACT_APP_API_MASTERY_ASSESSMENT}/studentlistperlevelsectionjson?level=${ass_options.level}&section=${ass_options.section}`).then((response) => {
                  if (response.data) {
                     const data = response.data;
                     setTreeData(data);

                     // var students = props.options.assigned_students.split(',');
                     // const finallist = students.map(e => 's_' + e);
                     // setCheckedKeys(finallist);

                     var students = props.options.assigned_students_with_section.split(',');
                     setCheckedKeys(students);
                  } else {
                     setTreeData([]);
                     setCheckedKeys([]);
                     // setExpandedKeys([]);
                  }
                  setStudentListLoading(false);
               }, (error) => {
                  setStudentListLoading(false);
                  console.log(error.message);
               });

            }
         }, (error) => {
            setSectionLoading(false);
            console.log(error.message);
         });

         props.parentCallback(ass_options);
      }

   }, [props.options.id]);

   const onExpand = (expandedKeysValue) => {
      //console.log('onExpand', expandedKeysValue); // if not set autoExpandParent to false, if children expanded, parent can not collapse.
      // or, you can remove all expanded children keys.

      setExpandedKeys(expandedKeysValue);
      // setAutoExpandParent(false);
   };

   const onCheck = (checkedKeysValue) => {
      //console.log('onCheck', checkedKeysValue);
      setCheckedKeys(checkedKeysValue);

      //-- (start) with section ------------------------------
      const selectedStudsWithSection = checkedKeysValue.filter((e) => {
         return e.includes('_');
         //return e.includes('|');

      });

      ass_options.assigned_students_with_section = selectedStudsWithSection.join(',');

      //-- Remove the section part
      for (var i = 0; i < selectedStudsWithSection.length; i++) {
         selectedStudsWithSection[i] = selectedStudsWithSection[i].substring(selectedStudsWithSection[i].indexOf('_') + 1, selectedStudsWithSection[i].length);
         //selectedStudsWithSection[i] = selectedStudsWithSection[i].substring(selectedStudsWithSection[i].indexOf('|') + 1, selectedStudsWithSection[i].length);
      }

      var selected = [...new Set(selectedStudsWithSection)]; //-- Remove duplicate students
      ass_options.assigned_students = selected.join(',');
      //-- (end) with section ------------------------------

      // //-- (start) without section ------------------------------
      // const selectedStuds = checkedKeysValue.filter((e) => {
      //    return e.includes('s_');
      // });

      // ass_options.assigned_students = selectedStuds.join(',');
      // ass_options.assigned_students = ass_options.assigned_students.replace(/s_/g, '');
      // //-- (end) without section ------------------------------

      props.parentCallback(ass_options);
   };

   const onSelect = (selectedKeysValue, info) => {
      //console.log('onSelect', info);
      setSelectedKeys(selectedKeysValue);
   };

   const handleClose = (event) => {
      // props.parentCallback(ass_options);
      props.backCallback(ass_options);
   }

   const onDateTimeChange = (value, dateString) => {
      console.log('Selected Time: ', value);
      console.log('Formatted Selected Time: ', dateString);
      ass_options.start_date = dateString[0];
      ass_options.end_date = dateString[1];
      props.parentCallback(ass_options);
   }

   const onInterventionChange = (val) => {
      ass_options.teacher_intervene = parseInt(val.target.value);
      props.parentCallback(ass_options);
   }

   const onRandomizeQuestionsChange = (val) => {
      ass_options.randomize_questions = parseInt(val.target.value);
      props.parentCallback(ass_options);
   }

   const handleSave = () => {
      localStorage.setItem("_assoptions", JSON.stringify(ass_options));
      console.log(localStorage.getItem("_assoptions"));
      props.saveCallback(ass_options);
   }

   const handleLevelChange = (val) => {
      // setAssLevel(val);
      ass_options.level = val;

      setSectionList([]);
      setTreeData([]);
      setCheckedKeys([]);
      setExpandedKeys([]);

      if (val === undefined || val === null || val === '') {
         setSectionLoading(false);
         setStudentListLoading(false);
         props.parentCallback(ass_options);
         return;
      }

      setSectionLoading(true);

      axios.get(`${process.env.REACT_APP_API_LOOKUP}/sectionlistbylevel?level=${val}`).then((response) => {
         if (response.data) {
            const data = response.data;

            setSectionList(data);
            setSectionLoading(false);
         }
      }, (error) => {
         setSectionLoading(false);
         console.log(error.message);
      });

      // axios.get(`${process.env.REACT_APP_API_MASTERY_ASSESSMENT}/studentlistperleveljson?level=${val}`).then((response) => {
      //    if (response.data) {
      //       const data = response.data;
      //       setTreeData(data);
      //       setCheckedKeys([]);
      //       setExpandedKeys([]);
      //    }
      // }, (error) => {
      //    console.log(error.message);
      // });

      // props.parentCallback(ass_options);
   }

   const handleSectionChange = (val) => {
      ass_options.section = val;
      setTreeData([]);
      setCheckedKeys([]);
      setExpandedKeys([]);

      if (val === undefined || val === null || val === '') {
         setStudentListLoading(false);
         props.parentCallback(ass_options);
         return;
      }

      setStudentListLoading(true);
      axios.get(`${process.env.REACT_APP_API_MASTERY_ASSESSMENT}/studentlistperlevelsectionjson?level=${ass_options.level}&section=${val}`).then((response) => {
         if (response.data) {
            const data = response.data;
            setTreeData(data);
            setCheckedKeys([]);
            setExpandedKeys([]);
         }
         setStudentListLoading(false);
      }, (error) => {
         setStudentListLoading(false);
         console.log(error.message);
      });

      props.parentCallback(ass_options);
   }

   const selectedStudentCount = checkedKeys.filter((key) => key.includes('_')).length;
   const hasSelectedLevel = props.options.level !== undefined && props.options.level !== null && props.options.level !== '' && props.options.level !== 0;
   const hasSelectedSection = props.options.section !== undefined && props.options.section !== null && props.options.section !== '' && props.options.section !== 0;

   const renderSaveRow = () => (
      <Row className="assessment-assign-drawer-save-row">
         <Col span={24} className="gutter-row">
            <Button
               className="button-shadow assessment-assign-drawer-save-button"
               type="primary"
               block
               shape="round"
               onClick={props.mode === "drawer" ? handleSave : handleClose}
            >
               <Text ellipsis style={{ color: "#fff" }}>
                  {props.mode === "drawer" ? <><SaveOutlined />&nbsp;Save</> : <><ArrowLeftOutlined />&nbsp;Back</>}
               </Text>
            </Button>
         </Col>
      </Row>
   );

   return (
      <div className="assessment-assign-panel">
         <section className="assessment-assign-section">
            <div className="assessment-assign-section-header">
               <span className="assessment-assign-section-icon"><SettingOutlined /></span>
               <div>
                  <Text className="assessment-assign-kicker">Options</Text>
                  <h3>Assignment Settings</h3>
               </div>
            </div>

            <div className="assessment-assign-title-card">
               <Text className="assessment-assign-title-label">Competency Title</Text>
               <Text className="assessment-assign-title-value">{ass_options.title}</Text>
            </div>

            <div className="assessment-assign-options-grid">
            {
               ass_options.assessment_type === 'formative' &&
               <>
                  <label className="assessment-assign-field">
                     <span><UsergroupAddOutlined /> Teacher Intervention</span>
                     <Radio.Group
                        name='teacher_intervene'
                        defaultValue={'0'}
                        value={ass_options.teacher_intervene.toString()}
                        buttonStyle='solid'
                        onChange={(e) => onInterventionChange(e)}
                     >
                        <Radio.Button value="1">Yes</Radio.Button>
                        <Radio.Button value="0">No</Radio.Button>
                     </Radio.Group>
                  </label>
                  {
                     ass_options.mode === 2 &&
                     <label className="assessment-assign-field">
                        <span><FieldTimeOutlined /> Randomize Questions</span>
                        <Radio.Group
                           name='randomize_question'
                           defaultValue={'0'}
                           value={ass_options.randomize_questions.toString()}
                           buttonStyle='solid'
                           onChange={(e) => onRandomizeQuestionsChange(e)}
                        >
                           <Radio.Button value="1">Yes</Radio.Button>
                           <Radio.Button value="0">No</Radio.Button>
                        </Radio.Group>
                     </label>
                  }
               </>
            }

            <label className="assessment-assign-field is-wide">
               <span><CalendarOutlined /> Schedule</span>
               <RangePicker
                  showTime={{ format: 'hh:mm A', use12Hours: true }}
                  format={customFormat}
                  onChange={onDateTimeChange}
                  value={
                     [ass_options.start_date !== "" ? moment(ass_options.start_date) : "",
                     ass_options.end_date !== "" ? moment(ass_options.end_date) : ""]
                  }
               />
            </label>
            </div>
         </section>

         <section className="assessment-assign-section">
            <div className="assessment-assign-section-header">
               <span className="assessment-assign-section-icon"><UsergroupAddOutlined /></span>
               <div>
                  <Text className="assessment-assign-kicker">Recipients</Text>
                  <h3>Assign Students</h3>
               </div>
               <span className="assessment-assign-count">{selectedStudentCount}</span>
            </div>
            <div className="assessment-assign-recipient-card">
               <div className="assessment-assign-recipient-grid">
                     <Select
                        showArrow
                        size='default'
                        className="assessment-assign-level-select"
                        allowClear
                        placeholder="Select Level"
                        onChange={(val) => handleLevelChange(val)}
                        value={props.options.level}
                     >
                        {Levels.map(({ value, name }, idx) => {
                           return <Option value={value}>{name}</Option>
                        })}
                     </Select>
                     <Select
                        showArrow
                        loading={sectionLoading}
                        size='default'
                        className="assessment-assign-level-select"
                        allowClear
                        placeholder="Select Section"
                        onChange={(val) => handleSectionChange(val)}
                        value={props.options.section}
                     >
                        {sectionList.map(({ value, name }, idx) => {
                           return <Option value={value}>{name}</Option>
                        })}
                     </Select>
               </div>

               {studentListLoading
                  ? <div className="assessment-assign-empty-state"><Spin /></div>
                  : hasSelectedLevel && hasSelectedSection && treeData.length > 0
                     ?
                     <div className="assessment-assign-tree-shell">
                        <Tree
                           checkable
                           onExpand={onExpand}
                           expandedKeys={expandedKeys}
                           autoExpandParent={true}
                           onCheck={onCheck}
                           checkedKeys={checkedKeys}
                           onSelect={onSelect}
                           selectedKeys={selectedKeys}
                           treeData={treeData}
                           defaultExpandParent={true}
                        />
                     </div>
                     :
                     hasSelectedLevel && hasSelectedSection &&
                     <div className="assessment-assign-empty-state">
                        <Empty image="../images/brainee_mascot.png" description="No students found" />
                     </div>
               }
            </div>
         </section>

         {props.manualSaveSlotId && manualSaveSlotReady && document.getElementById(props.manualSaveSlotId)
            ? createPortal(renderSaveRow(), document.getElementById(props.manualSaveSlotId))
            : (!props.manualSaveSlotId ? renderSaveRow() : null)
         }
      </div>
   )
}
